import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollTriggerClass {
  constructor(el) {
    this.dom = {el: el};
    this.dom.target = document.querySelector('[data-js="stc-target"]');

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    // [...this.dom.el].forEach((el, index) => {
    // });
    ScrollTrigger.create({
      trigger: this.dom.el,
      id: 1,
      start: 'top -100%',
      end: 'bottom -100%',
      toggleClass: {
        targets: this.dom.target,
        className: 'is-hidden'
      },
      once: false,
      markers: false,
    });
  }
}

export default ScrollTriggerClass